if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"NuOrderFrontend","remotes":[{"alias":"OrderIntents","name":"OrderIntents","entry":"/federated/order-intents/remoteEntry.js","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^1(6[123456789]|7[012345678]|57|58)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}